import React from "react"
import "./LoginSignUpBanner.scss"
import { selectIcon, SVG } from "../../UI/selector"
const LoginSignUpBanner = ({
  heading,
  subHeading1,
  subHeading2,
  subHeading3,
  isLogoRequired,
  ...props
}) => {
  return (
    <section className="SignIn">
      <div className="containerSection">
        <div className="containerSubSection">
          <div className="leftSection">
            <img src={selectIcon("leftSection")} alt={""} />
          </div>
          <div className="rightSection">
            {isLogoRequired && <img className="logo" alt="" />}
            <div className="formContainer">
              {heading && (
                <div className="headingContainer">
                  <p className="welcomeText">{heading}</p>
                </div>
              )}
              {subHeading1 && (
                <div className="headingContainer">
                  <p className="headingText">{subHeading1}</p>
                </div>
              )}
              {subHeading2 && (
                <div className="headingContainer">
                  <p className="headingText">{subHeading2}</p>
                </div>
              )}
              {subHeading3 && (
                <div className="headingContainer">
                  <p className="subHeading">{subHeading3}</p>
                </div>
              )}

              {/* =========== CHILD COMPONENT ============ */}
              {props.children}
              {/* =========== CHILD COMPONENT ============ */}
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default LoginSignUpBanner
